import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormEditarUsuarios from './FormEditarUsuario';

import updateUsuario from '../../../graphql/mutations/auth/updateUsuario.graphql';
import getUsuarioPorId from '../../../graphql/querys/auth/getUsuarioPorId.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(updateUsuario, {
    name: 'updateUsuario',
  })
)
class EditarUsuario extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      usuario: {},
      loading: true,
    };

    this.props.client
      .query({
        query: getUsuarioPorId,
        variables: { id: this.props.match.params.id },
      })
      .then(res => {
        const usuario = res.data.getUsuarioPorId;

        this.setState({
          loading: false,
          usuario: usuario,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarPersona = this.guardarPersona.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarPersona(usuario) {
    // console.log("La persona es...");
    // console.log(usuario);
    this.setState(
      {
        usuario: {
          ...this.state.usuario,
          ...usuario,
        },
      },
      function() {
        let nuevaPersona = this.state.usuario;
        delete nuevaPersona.organismo;
        delete nuevaPersona.__typename;
        delete nuevaPersona._id;

        this.props
          .updateUsuario({
            variables: {
              id: this.props.match.params.id,
              nuevoUsuario: nuevaPersona,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos del usuario',
            });

            this.props.history.push('/admin/usuarios');
          })
          .catch(err => {
            console.log('Error en la actualizacion del usuario');
            console.log(err);
            errorService(err, {
              id: this.props.match.params.id,
              nuevoUsuario: nuevaPersona,
            });

            Modal.error({
              title: 'Error en la actualizacion de los datos del usuario',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Usuario</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Usuario
          </h2>
          <br />
          <div style={estiloContent}>
            <FormEditarUsuarios
              className="formularios"
              onSubmit={this.guardarPersona}
              onAnterior={() => this.props.history.push('/admin/usuarios')}
              datos={this.state.usuario}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarUsuario);
